import { isWindowsPlatform } from "@/lib/os-platform";

export const CURSOR_INPUT_SCREENSHOT_CAPTURE_SCOPE = "cursor_screen" as const;

export function voiceScreenshotCaptureTarget(displayId: number | null) {
  // Windows supports cursor capture but not the explicit-display command yet.
  return displayId == null || isWindowsPlatform()
    ? CURSOR_INPUT_SCREENSHOT_CAPTURE_SCOPE
    : { displayId };
}

export function shouldCaptureCursorInputScreenshot(
  screenshotIntent: boolean,
  selectionPresent: boolean,
): boolean {
  return screenshotIntent || selectionPresent;
}
